module.exports = __webpack_public_path__ + "assets/ge-cbfed8cc1a1500e2fc1a35813a25736a.svg";